goog.provide('el8.appchart.refpanel.family');

goog.require('el8.appchart.metrics');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.icd9Codes');
goog.require('el8.data.snomedCodes');
goog.require('el8.data.practiceSettings');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.familyRelationshipItems');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.refpanel.family');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Component');
goog.require('el8.uiwidget.listeditor');

el8.appchart.refpanel.family = (function() {

    var listeditors = {};
    var $container = $('#structured-family-history-list');

    var that = new el8.uiwidget.Component({

        initFn: function() {
            $('#pfsh-summary').on('change', '.add-structured-relationship-select',  function() {
                var $this = $(this);
                var relationshipType = parseInt($this.val(), 10);
                if (isNaN(relationshipType)) { return; }

                el8.ptdata.ptFamilyRelationships.saveNew({
                    relationshipType: relationshipType
                });
                $this.val(''); // reset the <select>, regardless of whether the save succeeds
            });

            $container.on('click', '.remove-relationship-trigger',  function() {
                var relationshipId = $(this).data('id');
                var relationship = el8.ptdata.ptFamilyRelationships.getById(relationshipId);

                // refuse to delete if there are history items here
                if (relationship.getItemIds().length) {
                    el8.uiwidget.alert('This relationship still has history items in it. If you really want ' +
                        'to remove this whole relationship, please delete those first.');
                    return;
                }

                // otherwise, do so without confirmation
                el8.ptdata.ptFamilyRelationships.deleteItem(relationship);
            });

            $(document).on('el8_refBoardChange', function() {
                that.resizeAdjust();
            });
        },
        dataRenderers: [
            {
                entitySet: el8.ptdata.ptFamilyRelationships,
                events: [{
                    eventName: 'all',
                    fn: renderListeditors
                }],
                renderFn: renderListeditors
            }
        ]
    });

    that.editItem = function(id) {
        if (!id) { return null; }
        var familyItem = el8.ptdata.familyRelationshipItems.getById(id);
        var le = listeditors[familyItem.getRelationshipId()];

        var $entry = le.getEntryById(id);
        le.editEntry($entry);
    };
    that.removeItem = function(id, type) {
        if (!id) { return null; }
        var familyItem = el8.ptdata.familyRelationshipItems.getById(id);
        var le = listeditors[familyItem.getRelationshipId()];

        var $entry = le.getEntryById(id);
        le.removeEntry($entry, true);
    };

    that.resizeAdjust = function() {
        for (var l in listeditors) {
            if (listeditors.hasOwnProperty(l)) {
                listeditors[l].resizeAdjust();
            }
        }
    };

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('family');
    function renderListeditors() {
        $container.empty();
        listeditors = {};
        el8.ptdata.ptFamilyRelationships.sorted().forEach(function(relationship) {
            var curListeditor = addNewListeditor(relationship);
            curListeditor.addEntries(relationship.getItems());
            listeditors[relationship.getId()] = curListeditor;
        });

        reportOnFirstLoad();
    }

    function addNewListeditor(relationship) {
        var relationshipName = relationship.getRelationshipTypeName();
        $container.append(
            el8.template.appchart.refpanel.family.relationshipBlock({
                relationshipName: relationshipName,
                relationshipId: relationship.getId()
            })
        );

        var listeditorOpts = {
            labelType: 'none',
            list: $('.structured-family-history-'+relationship.getId(), $container),
            noRemove: true,
            infoText: 'Type a family history item...',
            saveFn: function saveFamilyHistoryItem(id, text, index, opts) {
                opts = opts || {};

                // Figure out whether to save this as text, an ICD9, or a SNOMED
                var textType = 'text';
                /* Check if "text" is an ICD9 or SNOMED, because we'll store the code instead of a string then.
                 *
                 * Each call to "el8.data.snomedCodes.getByKey" for a given invalid `text` value will
                 * result in a request (because each request returns null). Hopefully checking only
                 * for strings that parse to numbers will avoid making that too expensive... */
                var newSnomed, newIcd9;
                if (el8.util.smart.validateIcd9Code(text) && el8.data.icd9Codes.getByKey(text)) {
                    textType = 'icd9';
                    newIcd9 = el8.data.icd9Codes.getByKey(text);
                } else if (el8.util.string.isNumber(text) &&  el8.data.snomedCodes.getByKey(text)) {
                    textType = 'snomed';
                    newSnomed = el8.data.snomedCodes.getByKey(text);
                }

                var familyItem;
                if (id) {
                    familyItem = el8.ptdata.familyRelationshipItems.getById(id);
                } else {
                    familyItem = el8.ptdata.familyRelationshipItems.create({
                        relationshipId: relationship.getId()
                    }, true);
                }

                // Now figure out if anything has actually changed, because saveFn gets called really aggresively
                var needsSave = (!id);
                if (textType === 'text' && (needsSave || text !== familyItem.getText()) ) {
                    needsSave = true;

                    familyItem.setText(text);
                    familyItem.setSnomedId(null);
                    familyItem.setIcd9Id(null);

                } else if (textType === 'snomed' && (needsSave || newSnomed.getCode() !== familyItem.getSnomedCode()) ) {
                    needsSave = true;

                    familyItem.setSnomedId(newSnomed.getId());
                    familyItem.setText(null);
                    familyItem.setIcd9Id(null);

                } else if (textType === 'icd9' && (needsSave || newIcd9.getCode() !== familyItem.getIcd9Code()) ) {
                    needsSave = true;

                    familyItem.setIcd9Id(newIcd9.getId());
                    familyItem.setSnomedId(null);
                    familyItem.setText(null);
                }

                // If nothing changed, just trigger the callback / return
                if (!needsSave) {
                    if (opts.successCb) { opts.successCb(familyItem); }
                    return familyItem;
                }

                // Otherwise, save our new item
                opts.async = false;
                return el8.ptdata.familyRelationshipItems.saveItem(familyItem, true, opts);
            },
            dropdownFn: function($target, id) {
                var familyItem = el8.ptdata.familyRelationshipItems.getById(id);
                el8.appchart.refpanel.actionsMenu.display(
                    $target, familyItem, {top: 14, left: 20}, el8.appshared.feedItemActions(familyItem)
                );
                return false;
            },
            removeFn: function(id) {
                return el8.ptdata.familyRelationshipItems.deleteItem(id);
            },
            getItemTextFn: function(item) {
                if (item.getSnomedId()) {
                    var snomed = el8.data.snomedCodes.getById(item.getSnomedId());
                    if (snomed) { return snomed.getCode(); }
                }
                if (item.getIcd9Id()) {
                    var icd9 = el8.data.icd9Codes.getById(item.getIcd9Id());
                    if (icd9) { return icd9.getCode(); }
                }
                return item.getText();
            },
            getItemDisplayOnlyTextFn: function(item) {
                if (!item) { return ''; }
                if (el8.model.idToModelClass(item) === 'PatientFamilyHistoryItem') {
                    item = el8.ptdata.familyRelationshipItems.getById(item);
                }
                if (item.getSnomedId()) {
                    var snomed = el8.data.snomedCodes.getById(item.getSnomedId());
                    if (snomed) { return snomed.getCode() + ' - ' + snomed.getDescription(); }
                }
                if (item.getIcd9Id()) {
                    var icd9 = el8.data.icd9Codes.getById(item.getIcd9Id());
                    if (icd9) { return icd9.getCode() + ' - ' + icd9.getDescription(); }
                }
                return item.getText();
            },
            getItemIdFn: function(item) { return item.getId(); }
        };
        if (el8Globals.FEATURES.MUReports) {
            var snomedOpts = $.extend(el8.appshared.mindreaderOpts.snomedCodes(), {
                urlParams: { 'fh_only': 1 },
                hideNoResults: true
            });
            $.extend(listeditorOpts, {
                infoText: 'Family history text or SNOMED',
                newMindreader: true,
                mindreaderOpts: snomedOpts
            });
        }
        var listeditor = new el8.uiwidget.listeditor(listeditorOpts);
        listeditor.init();

        return listeditor;
    }


    return that;

})();
